<template>
  <div class="container-fluid mx-0" style="width: 100%;">
    <div class="title-container d-flex flex-row">
      <div id="logo-container" class="d-flex flex-column align-items-center justify-content-center" height="100%">
        <img :src="clientLogo" alt="Logo" height="55" class="d-inline-block align-text-top logo" />
      </div>
      <div class="d-flex flex-column w-100">
        <div class="d-flex flex-column justify-content-between  w-100">


          <div class="d-flex flex-row justify-content-between  w-100">
            <div class="page-title mx-3 mt-3">
              <div>Crash Safety Manual</div>

            </div>
            <div id="export-date" class="mx-3 mt-3 text-black-50"><em>Exported on {{ todaysDate }}</em></div>
          </div>
          <div class="d-flex flex-row justify-content-between  w-100">
            <h1 class="mt-0 mx-3"> {{ page.name }}</h1>

            <button id="print-button" class="btn" @click="printPage()">
              <img src="/print_FILL.svg" class="print-icon" />
            </button>
          </div>
        </div>
      </div>
    </div>

    <!-- desktop -->
    <div class="d-none d-md-block">
      <div class="row pb-5">
        <div class="col-8">
          <div id="page-content" class="p-2 mx-3" v-html="htmlContent">
          </div>
        </div>
        <div class="col-4 multitopic-nav">
          <MultiTopicNav class="" style="min-width: 200px; max-width: 300px" :items="this.rightNavItems" />
        </div>
      </div>
    </div>
    <!-- mobile, reordering multitopic nav -->
    <div class="d-block d-sm-block d-md-none">
      <div class="row pb-5">
        <div class="col mx-3">
          <MultiTopicNav class="multitopic-nav" :items="this.rightNavItems" />

          <div class="py-1" id="page-content" v-html="htmlContent" data-bs-spy="scroll">
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>


import MultiTopicNav from "@/components/page_elements/MultiTopicNav.vue";

import GDOTLogo from "/public/gdot-logo.png";

// Get HTML Content
async function loadPageContent(htmlFile) {
  if (!htmlFile) return "<!-- No HTML File for this page -->";

  return (await import(`@/pages/${htmlFile}`)).default;
}

export default {
  name: "PageView",
  components: {
    MultiTopicNav,
  },
  props: {
    page: Object,
    content: Object
  },
  data() {
    return {
      rightNavItems: this.page.headings,
      clientLogo: GDOTLogo,
      todaysDate: new Date().toLocaleDateString(),
      htmlContent: '<!-- Loading... -->'
    };
  },


  methods: {
    getID(name) {
      if (name) {
        let regex = /\W\.\s/g
        // Convert to lowercase and return the result.
        name = name.replace(regex, '')

        // Split name on whitespace, slashes, and ampersands and then capitalize each word.
        let words = name.split(/\W|\.\s/g);
        let capitalizedWords = words.map(word => {
          return word.charAt(0).toUpperCase() + word.slice(1);
        });
        // Join the capitalized words with a dash and return the result.
        let result = capitalizedWords.join('');
        // if the first char in result is a number, prepend 'num'
        if (result.charAt(0).match(/\d/)) {
          result = 'n' + result;
        }

        return result
      }
    },

    cleanFieldName(name) {
      //regex to remove all non-alphanumeric characters
      let regex = /:/g

      return name.replace(regex, '')

    },
    printPage() {
      window.print()
    },

  },
  async created() {
    this.htmlContent = await loadPageContent(this.page.htmlContent);
  },
};

</script>

<style scoped>
.title-container {
  display: flex;
  flex-direction: row;
  flex-wrap: nowrap;
  align-items: stretch;
  justify-content: space-between;
  width: 98%;
  border: 0;
  border-bottom: 1px solid rgba(0, 0, 0, .25);
  ;
}

.print-icon {
  height: 50px;
}

.print-icon:hover {
  filter: contrast(0.6);
}


@media print {
  #print-button {
    display: none;
  }

  .multitopic-nav {
    display: none;
  }

  .title-container {
    justify-content: start;
  }

  /* Avoid breaking each section content, esentially a page break if needed between content
    .section {
        break-inside: avoid;
    } */

  /* Expand all accordian sections */
  .collapse {
    display: block !important;
    height: auto !important;

  }

  .form-snippet {
    min-width: 100%;
  }

  .form-snippet.portrait-img {
    width: auto !important;
    max-height: 800px;
    min-width: auto !important;
  }

}

@media screen {
  #logo-container {
    display: none !important;
  }

  #export-date {
    display: none !important;
  }
}
</style>

<!-- non-scoped style bc scoped styles do not apply to v-html content -->
<style>
.form-number {
  font-weight: 700;
  color: rgb(178, 0, 0);
  margin-left: -1.8em;
}

.form-section {
  margin-left: 2em;
}

.inline-icon {
  height: 45px;
}

.faq-image {
  max-height: 80vh;
}

@media screen and (min-width: 768px) {
  #page-content img {
    max-width: 100%;
    padding: 10px 0 10px 0;
  }
}

@media screen and (max-width: 768px) {
  #page-content img {
    width: 100%;
    padding: 5px 5px 0 5px;
  }

}
</style>